import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;

import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
// https://observablehq.com/@aotten/scatterplot-routes-en-occitanie-v2-0@1055
import define1 from "./e93997d5089d7165@2303.js";
import define2 from "./a2166040e5fb39a6@229.js";
import define3 from "./576f8943dbfbd395@114.js";
export default function define(runtime, observer) {
  var main = runtime.module();
  var fileAttachments = new Map([["km_routes_communes_occ_2.csv", new URL("./files/2430a9867d4ac92d0cffcfe0613e696913d064cccd6e1226f175fcf922eadd3a18cd50cc22732218a4a4e894feff03ae79d3d1ee9591015c05bacf0fbe20f2b0", import.meta.url)]]);
  main.builtin("FileAttachment", runtime.fileAttachments(function (name) {
    return fileAttachments.get(name);
  }));
  main.variable(observer("paragraph1")).define("paragraph1", ["md"], function (md) {
    return md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n# <span style=\"color:green\"> Scatterplot routes en occitanie V2.0</span>\n## en km/hab par commune et par type de routes (typologie OSM)\n\n---\nVoir annexe  1 pour plus d'information sur les donn\xE9es <sup>[[1](#footnote1)]</sup> \n\nVoir annexe  2 pour les autres r\xE9f\xE9rences <sup>[[2](#footnote2)]</sup> \n\nVoir annexe  3 pour la to do list <sup>[[3](#footnote3)]</sup> \n\n---\n"])));
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["## INTERFACE UTILISATEUR \n"])));
  });
  main.variable(observer("viewof select_valeur")).define("viewof select_valeur", ["select"], function (select) {
    return select({
      title: "",
      description: "Choisissez unun type de route (nomenclature OSM).",
      options: ['residential', 'secondary', 'service', 'tertiary', 'unclassified', 'primary', 'motorway', 'trunk', 'total_all_road'],
      value: 'total_all_road'
    });
  });
  main.variable(observer("select_valeur")).define("select_valeur", ["Generators", "viewof select_valeur"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer("viewof select_dept")).define("viewof select_dept", ["select"], function (select) {
    return select({
      title: "",
      description: "Choisissez un département d'occitanie. 0 = tous les départements.",
      options: [{
        label: 'Occitanie',
        value: 0
      }, {
        label: 'Ariège',
        value: 9
      }, {
        label: 'Aude',
        value: 11
      }, {
        label: 'Aveyron',
        value: 12
      }, {
        label: 'Gard',
        value: 30
      }, {
        label: 'Haute-Garonne',
        value: 31
      }, {
        label: 'Gers',
        value: 32
      }, {
        label: 'Hérault',
        value: 34
      }, {
        label: 'Lot',
        value: 46
      }, {
        label: 'Lot et Garonne',
        value: 48
      }, {
        label: 'Hautes-Pyrénées',
        value: 65
      }, {
        label: 'Pyrénées Orientales',
        value: 66
      }, {
        label: 'Tarn',
        value: 80
      }, {
        label: 'Tarn et Garonne',
        value: 82
      }],
      value: 0
    });
  });
  main.variable(observer("select_dept")).define("select_dept", ["Generators", "viewof select_dept"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["## OUTPUT \n"])));
  });
  main.variable(observer()).define(["d3", "domains", "color_legend"], function (d3, domains, color_legend) {
    var svg = d3.create("svg").attr("width", 600).attr("height", 150); // Legend as a group

    var legend = svg.append("g") // Apply a translation to the entire group
    .attr("transform", "translate(100, 10)");
    var size = 20;
    var border_padding = 15;
    var item_padding = 5;
    var text_offset = 2; // Border

    legend.append('rect').attr("width", 450).attr("height", 100).style("fill", "black").style("stroke-width", 1).style("stroke", "black"); // Boxes

    legend.selectAll("boxes").data(domains).enter().append("rect").attr("x", border_padding).attr("y", function (d, i) {
      return border_padding + i * (size + item_padding);
    }).attr("width", size).attr("height", size).style("fill", function (d) {
      return color_legend(d);
    }); // Labels

    legend.selectAll("labels").data(domains).enter().append("text").attr("x", border_padding + size + item_padding).attr("y", function (d, i) {
      return border_padding + i * (size + item_padding) + size / 2 + text_offset;
    }) // .style("fill", (d) => color(d))
    .style("fill", "#eee").text(function (d) {
      return d;
    }).attr("text-anchor", "left").style("alignment-baseline", "middle").style("font-family", "sans-serif");
    return svg.node();
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["### GRAPHIQUE Echelle lin\xE9aire\n"])));
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["#### Nuage de points\n"])));
  });
  main.variable(observer("chart_lin")).define("chart_lin", ["d3", "DOM", "size", "width", "margin", "xAxis_lin", "yAxis_lin", "data", "xScale_lin", "yScale_lin", "select_valeur", "territoire", "select_dept"], function (d3, DOM, size, width, margin, xAxis_lin, yAxis_lin, data, xScale_lin, yScale_lin, select_valeur, territoire, select_dept) {
    // -----------------------------------------Variables associées au graphique. ----------------------------
    // -----------------------------------------Fonctions associées au graphique. ----------------------------
    var format = d3.format(".0f"); // ---------------------------------------------- Création du svg .---------------------------------------

    var svg = d3.select(DOM.svg(size.width, size.height));
    var background = svg.append('rect').attr('width', width).attr('height', size.height).attr('fill', "#000"); // ---------------------------------------------- Tracé des axes. ------------------------------------

    svg.append('g').attr('transform', "translate(0, ".concat(size.height - margin.bottom, ")")).call(xAxis_lin);
    svg.append('g').attr('transform', "translate(".concat(margin.left, ", 0)")).call(yAxis_lin); // ---------------------------------------------- Tracé des points. --------------------------------

    svg.append("g").attr("stroke", "none").attr("stroke-opacity", .2).selectAll("circle").data(data).enter().append("circle").attr("opacity", 1).attr('fill', function (d) {
      return d.population < 250 ? "#ec7014" : d.population > 2000 ? "#993404" : "#fec44f";
    }).attr("cx", function (d) {
      return xScale_lin(d.superficie);
    }).attr("cy", function (d) {
      return yScale_lin(d[select_valeur] / d['population']);
    }).attr("r", 1);
    svg.append("g").selectAll('text').data(data).join('text').attr('font-size', 12).attr('font-family', 'sans-serif').attr('dominant-baseline', 'hanging').attr("x", function (d) {
      return xScale_lin(d['population']);
    }).attr("y", function (d) {
      return yScale_lin(d[select_valeur]) - 10;
    }).text(function (d) {
      return d['population'] > 200000 ? d.commune + ' (' + format(d[select_valeur] / d['population'] * 1000) + ' mètre/hab)' : "";
    }); // ---------------------------------------------- Titre du graphique. --------------------------------

    svg.append("text").attr("class", "xlabel").attr("y", 0).attr("x", size.width / 2 + margin.left / 2).attr("dy", "1.8em").style("font", "14px sans-serif ").style("fill", "#eee").style("text-anchor", "middle").text('kilométrage des routes  (' + select_valeur + ') en km/habitant et par communes en ' + territoire(select_dept));
    svg.append("text").attr("transform", "translate(" + margin.left / 2 + "," + size.height / 2 + ")rotate(-90)").style("text-anchor", "middle").attr('font-size', "14").style("fill", "#eee").text("kilométrage / habitant");
    svg.append("text").attr("transform", "translate(" + width / 2 + "," + (size.height - 10) + ")").style("text-anchor", "middle").attr('font-size', "14").attr('fill', "#eee").text("Superficie de la commune en km²");
    svg.selectAll(".tick text").attr("fill", "#eee");
    svg.selectAll(".tick line").attr("stroke", "#eee");
    svg.selectAll(".domain").attr("stroke", "#eee");
    return svg.node();
  });
  main.variable(observer("graph_svg")).define("graph_svg", ["DOM", "serialize", "chart", "select_valeur"], /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(DOM, serialize, chart, select_valeur) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = DOM;
              _context.next = 3;
              return serialize(chart);

            case 3:
              _context.t1 = _context.sent;
              _context.t2 = 'linearScale_scatterplot_occ_road_' + select_valeur + '.svg';
              _context.t3 = 'Download linearScale_scatterplot_' + select_valeur + ' road as svg';
              return _context.abrupt("return", _context.t0.download.call(_context.t0, _context.t1, _context.t2, _context.t3));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }());
  main.variable(observer("graph_png")).define("graph_png", ["DOM", "rasterize", "chart", "select_valeur"], /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(DOM, rasterize, chart, select_valeur) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = DOM;
              _context2.next = 3;
              return rasterize(chart);

            case 3:
              _context2.t1 = _context2.sent;
              _context2.t2 = 'linearScale_scatterplot_occ_road_' + select_valeur + '.png';
              _context2.t3 = 'Download linearScale_scatterplot_' + select_valeur + ' road as png';
              return _context2.abrupt("return", _context2.t0.download.call(_context2.t0, _context2.t1, _context2.t2, _context2.t3));

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x5, _x6, _x7, _x8) {
      return _ref2.apply(this, arguments);
    };
  }());
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["### GRAPHIQUE Echelle Log"])));
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["#### Nuage de points\n"])));
  });
  main.variable(observer("chart")).define("chart", ["d3", "DOM", "size", "width", "margin", "xAxis", "yAxis", "data", "xScale", "yScale", "select_valeur", "territoire", "select_dept"], function (d3, DOM, size, width, margin, xAxis, yAxis, data, xScale, yScale, select_valeur, territoire, select_dept) {
    // -----------------------------------------Variables associées au graphique. ----------------------------
    // -----------------------------------------Fonctions associées au graphique. ----------------------------
    var format = d3.format(".1f"); // ---------------------------------------------- Création du svg .---------------------------------------

    var svg = d3.select(DOM.svg(size.width, size.height));
    var background = svg.append('rect').attr('width', width).attr('height', size.height).attr('fill', "#000"); // ---------------------------------------------- Tracé des axes. ------------------------------------

    svg.append('g').attr('transform', "translate(0, ".concat(size.height - margin.bottom, ")")).call(xAxis);
    svg.append('g').attr('transform', "translate(".concat(margin.left, ", 0)")).call(yAxis); // ---------------------------------------------- Tracé des points. --------------------------------

    svg.append("g").attr("stroke", "none").attr("stroke-opacity", 0.2).selectAll("circle").data(data).enter().append("circle").attr("opacity", 1).attr('fill', function (d) {
      return d.population < 250 ? "#ec7014" : d.population > 2000 ? "#993404" : "#fec44f";
    }).attr("cx", function (d) {
      return xScale(d['superficie']);
    }).attr("cy", function (d) {
      return yScale(d[select_valeur] / d['population']);
    }).attr("r", 1);
    svg.append("g").selectAll('text').data(data).join('text').attr('font-size', 10).attr('font-family', 'sans-serif').attr('fill', "#eee").attr('dominant-baseline', 'hanging').attr("x", function (d) {
      return xScale(d['superficie']);
    }).attr("y", function (d) {
      return yScale(d[select_valeur] / d['population']) + 10;
    }).text(function (d) {
      return d['population'] > 200000 ? d.commune + ' (' + format(d[select_valeur] / d['population'] * 1000) + ' mètre/hab)' : "";
    }); // ---------------------------------------------- Titre du graphique. --------------------------------

    svg.append("text").attr("class", "xlabel").attr("y", 0).attr("x", size.width / 2 + margin.left / 2).attr("dy", "1.8em").style("font", "14px sans-serif ").style("fill", "#eee").style("text-anchor", "middle").text('kilométrage des routes  (' + select_valeur + ') en km/habitant et par communes en ' + territoire(select_dept));
    svg.append("text").attr("transform", "translate(" + margin.left / 2 + "," + size.height / 2 + ")rotate(-90)").style("text-anchor", "middle").attr('font-size', "14").attr('fill', "#eee").text("Kilométrage / habitant");
    svg.append("text").attr("transform", "translate(" + width / 2 + "," + (size.height - 10) + ")").style("text-anchor", "middle").attr('font-size', "14").attr('fill', "#eee").text("Superficie de la commune en km²");
    svg.selectAll(".tick text").attr("fill", "#eee");
    svg.selectAll(".tick line").attr("stroke", "#eee");
    svg.selectAll(".domain").attr("stroke", "#eee");
    return svg.node();
  });
  main.variable(observer("log_graph_svg")).define("log_graph_svg", ["DOM", "serialize", "chart", "select_valeur"], /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(DOM, serialize, chart, select_valeur) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = DOM;
              _context3.next = 3;
              return serialize(chart);

            case 3:
              _context3.t1 = _context3.sent;
              _context3.t2 = 'logScale_scatterplot_occ_road_' + select_valeur + '.svg';
              _context3.t3 = 'Download logScale_scatterplot_' + select_valeur + ' road as svg';
              return _context3.abrupt("return", _context3.t0.download.call(_context3.t0, _context3.t1, _context3.t2, _context3.t3));

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x9, _x10, _x11, _x12) {
      return _ref3.apply(this, arguments);
    };
  }());
  main.variable(observer("log_graph_png")).define("log_graph_png", ["DOM", "rasterize", "chart", "select_valeur"], /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(DOM, rasterize, chart, select_valeur) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = DOM;
              _context4.next = 3;
              return rasterize(chart);

            case 3:
              _context4.t1 = _context4.sent;
              _context4.t2 = 'logScale_scatterplot_occ_road_' + select_valeur + '.png';
              _context4.t3 = 'Download logScale_scatterplot_' + select_valeur + ' road as png';
              return _context4.abrupt("return", _context4.t0.download.call(_context4.t0, _context4.t1, _context4.t2, _context4.t3));

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x13, _x14, _x15, _x16) {
      return _ref4.apply(this, arguments);
    };
  }());
  main.variable(observer("tooltip")).define("tooltip", ["chart", "d3"], function (chart, d3) {
    chart;
    var tooltip = d3.select('body').append('div').attr('class', 'tooltip').style('position', 'absolute').style('visibility', 'hidden').text('valeur');
    d3.selectAll("circle").on("mouseover", function () {
      d3.select(this).transition().attr('r', 4);
    })
    /*.on("mousemove", function() {
      return tooltip.style("visibility", "visible");
    })*/
    .on("mousemove", function (e, d) {
      return tooltip.html("<b>Commune :</b> ".concat(d.CODGEO, " ").concat(d.commune, "<br /><b>Nombre dhabitants :</b> ").concat(d['population'], "<br /><b>Total motorway en km :</b> ").concat(d3.format(".1f")(d.motorway), "<br /><b>Total trunk en km :</b> ").concat(d3.format(".1f")(d.trunk), "<br /><b>Total primary en km :</b> ").concat(d3.format(".1f")(d.primary), "<br /><b>Total secondary en km :</b> ").concat(d3.format(".1f")(d.secondary), "<br /><b>Total tertiary en km :</b> ").concat(d3.format(".1f")(d.tertiary), "<br /><b>Total residential en km :</b> ").concat(d3.format(".1f")(d.residential), "<br /><b>Total service en km :</b> ").concat(d3.format(".1f")(d.service), "<br /><b>Total unclassified en km :</b> ").concat(d3.format(".1f")(d.unclassified), "<br /><!--<b>Click to see more info.</b><br />-->\n")).style("top", e.pageY - 10 + "px").style("left", e.pageX + 20 + "px").style("visibility", "visible");
    }).on("mouseout", function () {
      d3.select(this).transition().attr("r", 1); //    .attr('r', d => (d.dep == dept ? 3 : 1.5));

      return tooltip.html("").style("visibility", "hidden");
    }); // .on("click", function(d) { window.open(d.URL); })
  });
  main.variable(observer("row_chart")).define("row_chart", ["width", "d3", "DOM", "data_sum", "territoire", "select_dept"], function (width, d3, DOM, data_sum, territoire, select_dept) {
    var height = width * 0.4;
    var svg = d3.select(DOM.svg(width, height));
    var background = svg.append('rect').attr('width', width).attr('height', height).attr('fill', '"black"');
    var margin = {
      top: 60,
      right: 100,
      bottom: 10,
      left: 280
    };
    var x = d3.scaleLinear().domain([0, d3.max(data_sum, function (d) {
      return d.sum;
    })]).range([margin.left, width - margin.right]);
    var y = d3.scaleBand().domain(data_sum.map(function (d) {
      return d.type;
    })).range([margin.top, height - margin.bottom]).padding(0.1);

    var xAxis = function xAxis(g) {
      return g.attr("transform", "translate(0,".concat(margin.top, ")")).call(d3.axisTop(x).ticks(width / 80)).call(function (g) {
        return g.select(".domain").remove();
      });
    };

    var yAxis = function yAxis(g) {
      return g.attr("transform", "translate(".concat(margin.left, ",0)")).call(d3.axisLeft(y).tickSizeOuter(0));
    };

    var format = x.tickFormat(20);
    var format = d3.format(".0f");
    var format_pourcent = d3.format(".1f");
    svg.append("g").selectAll("rect").data(data_sum).join("rect").attr("x", x(0)).attr("y", function (d) {
      return y(d.type);
    }).attr("fill", 'lightgrey').attr("width", function (d) {
      return x(d.sum) - x(0);
    }).attr("height", y.bandwidth());
    svg.append("g").attr("fill", "white").attr("text-anchor", "start").style("font", "20px sans-serif").selectAll("text").data(data_sum).join("text").attr("x", function (d) {
      return x(d.sum);
    }).attr("y", function (d) {
      return y(d.type) + y.bandwidth() / 2;
    }).attr('fill', '#999').attr("dy", "0.35em").attr("dx", "0.35em").text(function (d, i) {
      return d3.format(".0f")(d.sum) + ' km';
    });
    svg.append("g").append("text").attr("class", "xlabel").attr("y", 0).attr("x", width / 2).attr("dy", "1.8em").style("font", "18px sans-serif ").style("fill", "#f88502").style("text-anchor", "middle").text('Kilométrage des routes - ' + territoire(select_dept));
    /* 
    svg.append("g")
      .call(xAxis);
    */

    svg.append("g").attr("class", "axisColor").call(yAxis);
    return svg.node();
  });
  main.variable(observer("row_chart_svg")).define("row_chart_svg", ["DOM", "serialize", "row_chart", "territoire", "select_dept"], /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(DOM, serialize, row_chart, territoire, select_dept) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = DOM;
              _context5.next = 3;
              return serialize(row_chart);

            case 3:
              _context5.t1 = _context5.sent;
              _context5.t2 = 'kilometrage_routes_' + territoire(select_dept) + '.svg';
              _context5.t3 = 'Download kilometrage_routes ' + territoire(select_dept) + ' as svg';
              return _context5.abrupt("return", _context5.t0.download.call(_context5.t0, _context5.t1, _context5.t2, _context5.t3));

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x17, _x18, _x19, _x20, _x21) {
      return _ref5.apply(this, arguments);
    };
  }());
  main.variable(observer("row_chart_png")).define("row_chart_png", ["DOM", "rasterize", "row_chart", "territoire", "select_dept"], /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(DOM, rasterize, row_chart, territoire, select_dept) {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.t0 = DOM;
              _context6.next = 3;
              return rasterize(row_chart);

            case 3:
              _context6.t1 = _context6.sent;
              _context6.t2 = 'kilometrage_routes_' + territoire(select_dept) + '.png';
              _context6.t3 = 'Download kilometrage_routes ' + territoire(select_dept) + ' as png';
              return _context6.abrupt("return", _context6.t0.download.call(_context6.t0, _context6.t1, _context6.t2, _context6.t3));

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x22, _x23, _x24, _x25, _x26) {
      return _ref6.apply(this, arguments);
    };
  }());
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["## DATA \n"])));
  });
  main.variable(observer("raw_data")).define("raw_data", ["d3", "FileAttachment"], /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(d3, FileAttachment) {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.t0 = d3;
              _context7.next = 3;
              return FileAttachment("km_routes_communes_occ_2.csv").text();

            case 3:
              _context7.t1 = _context7.sent;
              _context7.t2 = d3.autoType;
              return _context7.abrupt("return", _context7.t0.csvParse.call(_context7.t0, _context7.t1, _context7.t2).filter(function (d) {
                return d['Total population commune'];
              }));

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x27, _x28) {
      return _ref7.apply(this, arguments);
    };
  }());
  main.variable(observer("data_road_type")).define("data_road_type", ["raw_data", "select_valeur"], function (raw_data, select_valeur) {
    return raw_data.filter(function (d) {
      return d[select_valeur] != 0;
    });
  });
  main.variable(observer("data_")).define("data_", ["select_dept", "data_road_type"], function (select_dept, data_road_type) {
    if (select_dept != "0") {
      return data_road_type.filter(function (d) {
        return +d['dept'] == select_dept;
      });
    } else {
      return data_road_type;
    }
  });
  main.variable(observer("data")).define("data", ["data_"], function (data_) {
    return data_.map(function (d) {
      return {
        CODGEO: d.CODGEO,
        commune: d.commune_y,
        population: d['Total population commune'],
        superficie: d.superficie / 100,
        residential: d.residential,
        secondary: d.secondary,
        tertiary: d.tertiary,
        service: d.service,
        unclassified: d.unclassified,
        primary: d.primary,
        motorway: d.motorway,
        trunk: d.trunk,
        total_all_road: d.total_all_road
      };
    });
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["### TABLEAU DES DONNEES \n"])));
  });
  main.variable(observer()).define(["printTable", "data"], function (printTable, data) {
    return printTable(data.slice(0, 2));
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["## DATA TRAITEMENT \n"])));
  });
  main.variable(observer("data_sum_")).define("data_sum_", ["d3", "data"], function (d3, data) {
    return {
      Residential: +d3.format(".0f")(d3.sum(data.map(function (d) {
        return d.residential;
      }))),
      Secondary: +d3.format(".0f")(d3.sum(data.map(function (d) {
        return d.secondary;
      }))),
      Service: +d3.format(".0f")(d3.sum(data.map(function (d) {
        return d.service;
      }))),
      Tertiary: +d3.format(".0f")(d3.sum(data.map(function (d) {
        return d.tertiary;
      }))),
      Unclassified: +d3.format(".0f")(d3.sum(data.map(function (d) {
        return d.unclassified;
      }))),
      Primary: +d3.format(".0f")(d3.sum(data.map(function (d) {
        return d.primary;
      }))),
      Trunk: +d3.format(".0f")(d3.sum(data.map(function (d) {
        return d.trunk;
      }))),
      Motorway: +d3.format(".0f")(d3.sum(data.map(function (d) {
        return d.motorway;
      }))),
      all_road: +d3.format(".0f")(d3.sum(data.map(function (d) {
        return d.motorway;
      })) + d3.sum(data.map(function (d) {
        return d.trunk;
      })) + d3.sum(data.map(function (d) {
        return d.primary;
      })) + d3.sum(data.map(function (d) {
        return d.unclassified;
      })) + d3.sum(data.map(function (d) {
        return d.tertiary;
      })) + d3.sum(data.map(function (d) {
        return d.service;
      })) + d3.sum(data.map(function (d) {
        return d.secondary;
      })) + d3.sum(data.map(function (d) {
        return d.residential;
      })))
    };
  });
  main.variable(observer("data_sum")).define("data_sum", ["data_sum_"], function (data_sum_) {
    var temp = [];
    temp.push({
      type: 'Residential',
      sum: data_sum_.Residential
    }, {
      type: 'Secondary',
      sum: data_sum_.Secondary
    }, {
      type: 'Service',
      sum: data_sum_.Service
    }, {
      type: 'Tertiary',
      sum: data_sum_.Tertiary
    }, {
      type: 'Unclassified',
      sum: data_sum_.Unclassified
    }, {
      type: 'Primary',
      sum: data_sum_.Primary
    }, {
      type: 'Trunk',
      sum: data_sum_.Trunk
    }, {
      type: 'Motorway',
      sum: data_sum_.Motorway
    });
    return temp.sort(function (a, b) {
      return a.sum - b.sum;
    });
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["## CONFIGURATION \n"])));
  });
  main.variable(observer("size")).define("size", ["width"], function (width) {
    return {
      width: width,
      height: 600
    };
  });
  main.variable(observer("margin")).define("margin", function () {
    return {
      top: 25,
      right: 80,
      bottom: 50,
      left: 100
    };
  });
  main.variable(observer("xScale")).define("xScale", ["d3", "data", "margin", "size"], function (d3, data, margin, size) {
    return d3.scaleLog().domain(d3.extent(data, function (d) {
      return d['superficie'];
    })).range([margin.left, size.width - margin.right]).nice();
  });
  main.variable(observer("xScale_lin")).define("xScale_lin", ["d3", "data", "margin", "size"], function (d3, data, margin, size) {
    return d3.scaleLinear().domain(d3.extent(data, function (d) {
      return d['superficie'];
    })).range([margin.left, size.width - margin.right]).nice();
  });
  main.variable(observer("yScale")).define("yScale", ["d3", "data", "select_valeur", "size", "margin"], function (d3, data, select_valeur, size, margin) {
    return d3.scaleLog() //.domain([0.001, d3.max(data.map(d => d[select_valeur] / d.population))])
    .domain(d3.extent(data.map(function (d) {
      return d[select_valeur] / d.population;
    }))).range([size.height - margin.bottom, margin.top]).nice();
  });
  main.variable(observer("yScale_lin")).define("yScale_lin", ["d3", "data", "select_valeur", "size", "margin"], function (d3, data, select_valeur, size, margin) {
    return d3.scaleLinear().domain([0, d3.max(data.map(function (d) {
      return d[select_valeur] / d.population;
    }))]).range([size.height - margin.bottom, margin.top]).nice();
  });
  main.variable(observer("xAxis")).define("xAxis", ["d3", "xScale"], function (d3, xScale) {
    return d3.axisBottom(xScale).ticks(10, "~s");
  });
  main.variable(observer("xAxis_lin")).define("xAxis_lin", ["d3", "xScale_lin"], function (d3, xScale_lin) {
    return d3.axisBottom(xScale_lin);
  });
  main.variable(observer("yAxis")).define("yAxis", ["d3", "yScale"], function (d3, yScale) {
    return d3.axisLeft(yScale).ticks(10, "~s");
  });
  main.variable(observer("yAxis_lin")).define("yAxis_lin", ["d3", "yScale_lin"], function (d3, yScale_lin) {
    return d3.axisLeft(yScale_lin);
  });
  main.variable(observer("color_legend")).define("color_legend", ["d3", "domains"], function (d3, domains) {
    return d3.scaleOrdinal(["#ec7014", "#fec44f", "#993404"]).domain(domains);
  });
  main.variable(observer("domains")).define("domains", function () {
    return ["Population commune <250 habitants", "Population commune >=250  et <= 2000 habitants", "Population commune >2000 habitants"];
  });
  main.variable(observer("territoire")).define("territoire", ["d3"], function (d3) {
    return d3.scaleOrdinal().domain([0, 9, 11, 12, 30, 31, 32, 34, 46, 48, 65, 66, 80, 82]).range(['Occitanie', 'Ariège', 'Aude', 'Aveyron', 'Gard', 'Haute-Garonne', 'Gers', 'Hérault', 'Lot', 'Lot et Garonne', 'Hautes-Pyrénées', 'Pyrénées Orientales', 'Tarn', 'Tarn et Garonne']).unknown("");
  });
  main.variable(observer()).define(["html"], function (html) {
    return html(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n<style>\n \n  .tooltip {\n        font-family: -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple   Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    background: rgba(69,77,93,.9);\n    border-radius: .1rem;\n    color: #fff;\n    display: block;\n    font-size: 11px;\n    max-width: 320px;\n    padding: .2rem .4rem;\n    position: absolute;\n    text-overflow: ellipsis;\n    white-space: pre;\n    z-index: 300;\n    visibility: hidden;\n  }\n\n  .tooltip p {\n    margin: 0;\n    padding: 0;\n  }\n\n.axisColor line{\n  stroke: #fff;\n}\n\n.axisColor path{\n  stroke: #fff;\n}\n\n.axisColor text{\n font-size : 20px;\n fill: orange;\n}\n\n</style>\n"])));
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["## LIBRAIRIES\n"])));
  });
  var child1 = runtime.module(define1);
  main.import("select", child1);
  main.import("color", child1);
  main.import("radio", child1);
  main.import("slider", child1);
  main.variable(observer("d3")).define("d3", ["require"], function (require) {
    return require("d3", "d3-regression");
  });
  var child2 = runtime.module(define2);
  main.import("printTable", child2);
  var child3 = runtime.module(define3);
  main.import("rasterize", child3);
  main.import("serialize", child3);
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["## INFORMATIONS & REFERENCES \n"])));
  });
  main.variable(observer("footnote")).define("footnote", ["html"], function (html) {
    return function (referencingCellName, number, text) {
      return html(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["<ol start=\"", "\"><li><a href=\"#", "\">^</a> ", "</li></ol>"], ["<ol start=\\\"", "\"><li><a href=\"#", "\">^</a> ", "</li></ol>"])), number, referencingCellName, text);
    };
  });
  main.variable(observer("footnote1")).define("footnote1", ["footnote"], function (footnote) {
    return footnote("paragraph1", 1, "ANNEXE  1");
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["Ce jeu de donn\xE9es a \xE9t\xE9 publi\xE9 le 21 juin 2014 et mis \xE0 jour le 24 juin 2014 \xE0 l'initiative et sous la responsabilit\xE9 de Christian Quest . Jeu de donn\xE9es produit \xE0 partir des donn\xE9es OpenStreetMap dans le cadre du hackathon du Minist\xE8re de l'Int\xE9rieur de Juin 2014.\n\n\nhttps://www.data.gouv.fr/fr/datasets/kilometrage-des-types-de-routes-repartis-par-communes/\n\nCe fichier avait \xE9t\xE9 int\xE9gr\xE9 dans le dataset de l\u2019hackaviz 2018 :\n\nhttp://toulouse-dataviz.fr/concours-hackaviz-2018\n\nPr\xE9paration des donn\xE9es \nJUPYTER_NOTEBOOKHACKAVIZ-2018HACHAVIZ_2018_AJOUT _DATA_DANS_FICHIER_commune_geometry2D.geojson_FORMAT_ CSV.ipynb\n\nLa preparation consiste essentiellement \xE0 regrouper sur une ligne tous les attributs de chaque commune et d'ajouter les donn\xE9es populations des communes. \n"], ["Ce jeu de donn\xE9es a \xE9t\xE9 publi\xE9 le 21 juin 2014 et mis \xE0 jour le 24 juin 2014 \xE0 l'initiative et sous la responsabilit\xE9 de Christian Quest . Jeu de donn\xE9es produit \xE0 partir des donn\xE9es OpenStreetMap dans le cadre du hackathon du Minist\xE8re de l'Int\xE9rieur de Juin 2014.\n\n\nhttps://www.data.gouv.fr/fr/datasets/kilometrage-des-types-de-routes-repartis-par-communes/\n\nCe fichier avait \xE9t\xE9 int\xE9gr\xE9 dans le dataset de l\u2019hackaviz 2018 :\n\nhttp://toulouse-dataviz.fr/concours-hackaviz-2018\n\nPr\xE9paration des donn\xE9es \nJUPYTER_NOTEBOOK\\HACKAVIZ-2018\\HACHAVIZ_2018_AJOUT _DATA_DANS_FICHIER_commune_geometry2D.geojson_FORMAT_ CSV.ipynb\n\nLa preparation consiste essentiellement \xE0 regrouper sur une ligne tous les attributs de chaque commune et d'ajouter les donn\xE9es populations des communes. \n"])));
  });
  main.variable(observer("footnote2")).define("footnote2", ["footnote"], function (footnote) {
    return footnote("paragraph1", 2, "ANNEXE  2");
  });
  main.variable(observer("footnote3")).define("footnote3", ["footnote"], function (footnote) {
    return footnote("paragraph1", 3, "ANNEXE  3");
  });
  return main;
}